// extracted by mini-css-extract-plugin
module.exports = {"button":"AddFormButton_button__1DS7r"};